import { recordEventWrapper } from '..';
import { getPageLabelForTransactionSuccess, getTitleForTransactionSuccess } from '../utils';

const transactInvest = () => ({
  onResendOTP: (userFlow: string) => {
    recordEventWrapper({
      event: 'event_pfm',
      category: 'PFM',
      action: `mutual funds | ${userFlow?.toLowerCase()} - otp verification`,
      label: `resend`
    });
  },
  
  onTransactionSuccessPageLoad: (userFlow?: string, schemeName?: string) => {
    recordEventWrapper({
      event: 'event_pfm_onload_vpv',
      page: `/vpv/pfm/mutual-funds/${getPageLabelForTransactionSuccess(userFlow)}/congratulations/${schemeName}`,
      title: `PFM - Mutual Funds - ${getTitleForTransactionSuccess(userFlow)} - Congratulations - ${schemeName}`,
    });
    recordEventWrapper({
      event: 'event_pfm_onload',
      category: `PFM`,
      action: `Pageload`,
      label: `mutual funds | ${getTitleForTransactionSuccess(userFlow)} - congratulations | ${schemeName}`,
    });
  }
});

export default transactInvest;
